import { defineComponent, ref, reactive, toRefs } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
export default defineComponent({
  setup() {
    const router = useRouter(); //路由实例，用于页面跳转

    const route = useRoute(); //路由对象，可以获取参数

    const store = useStore(); //vuex的状态实例

    const routePath = (path, query = '') => {
      let this_route = route.name; // 因为footer是通用组件。当前页面跳转当前页面会获取不到参数,所以使用vuex管理product中的sub-nav

      store.commit('switchProductNav', query); // 如果是跳转当前页面不使用路由

      if (this_route != path) {
        router.push({
          name: path
        });
      }
    };

    const urlRoute = () => {
      window.location.href = 'https://beian.miit.gov.cn/';
    };

    return {
      routePath,
      urlRoute
    };
  }

});